const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSEraser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-eraser",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-eraser1",
    serifid: "iconS-eraser"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ph-eraser"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.354,20.347l-8.852,-0l9.436,-9.437c0.448,-0.449 0.726,-1.069 0.726,-1.753c-0,-0.685 -0.278,-1.305 -0.726,-1.754l-4.676,-4.677c-0.449,-0.448 -1.069,-0.726 -1.754,-0.726c-0.685,-0 -1.305,0.278 -1.754,0.726l-11.691,11.692c-0.449,0.449 -0.727,1.069 -0.727,1.754c0,0.684 0.278,1.304 0.727,1.753l3.833,3.833c0.149,0.149 0.356,0.242 0.584,0.242l14.874,-0c0.456,-0 0.826,-0.37 0.826,-0.827c0,-0.456 -0.37,-0.826 -0.826,-0.826l-0,-0Zm-14.531,-0l-3.591,-3.591c-0.15,-0.149 -0.242,-0.356 -0.242,-0.584c-0,-0.229 0.092,-0.435 0.242,-0.585l4.377,-4.377l5.846,5.845l-3.291,3.292l-3.341,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSEraser);
export default __webpack_public_path__ + "static/media/iconS-eraser.afb5a2a33c918cfc0dfb50b918bf3687.svg";
export { ForwardRef as ReactComponent };